// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinkItem-module__font-s-10___KOaTv {
  font-size: 10px !important;
}

.LinkItem-module__font-s-12___iQ7DA {
  font-size: 12px !important;
}

.LinkItem-module__font-s-13___VEyhH {
  font-size: 13px !important;
}

.LinkItem-module__font-s-14___nKWzM {
  font-size: 14px !important;
}

.LinkItem-module__font-s-15___f5fy6 {
  font-size: 15px !important;
}

.LinkItem-module__font-s-16___NbIK9 {
  font-size: 16px !important;
}

.LinkItem-module__font-s-18___xovZq {
  font-size: 18px !important;
}

.LinkItem-module__font-s-20___ZGAkI {
  font-size: 20px !important;
}

.LinkItem-module__font-s-22___anz9U {
  font-size: 22px !important;
}

.LinkItem-module__font-s-28___ILmrE {
  font-size: 28px !important;
}

.LinkItem-module__font-w-400___LivND {
  font-weight: 400 !important;
}

.LinkItem-module__font-w-500___JIbu2 {
  font-weight: 500 !important;
}

.LinkItem-module__font-w-600___qscTn {
  font-weight: 600 !important;
}

.LinkItem-module__font-w-700___dD0CJ {
  font-weight: 700 !important;
}

.LinkItem-module__p-5____0pDY {
  padding: 5px !important;
}

.LinkItem-module__p-12___Lltv7 {
  padding: 12px !important;
}

.LinkItem-module__p-16___xMxc7 {
  padding: 16px !important;
}

.LinkItem-module__p-30___x7PC_ {
  padding: 30px !important;
}

.LinkItem-module__p-b-0___Vxp6z {
  padding-bottom: 0 !important;
}

.LinkItem-module__p-b-5___pofWt {
  padding-bottom: 5px !important;
}

.LinkItem-module__p-b-10___xkhUo {
  padding-bottom: 10px !important;
}

.LinkItem-module__p-b-12___bPEKo {
  padding-bottom: 12px !important;
}

.LinkItem-module__p-b-16___BMemU {
  padding-bottom: 16px !important;
}

.LinkItem-module__p-b-18___ESMkg {
  padding-bottom: 18px !important;
}

.LinkItem-module__p-b-20___D7hhQ {
  padding-bottom: 20px !important;
}

.LinkItem-module__p-b-25___GPpBP {
  padding-bottom: 25px !important;
}

.LinkItem-module__p-b-30___qTeyJ {
  padding-bottom: 30px !important;
}

.LinkItem-module__p-b-50___Vr1mj {
  padding-bottom: 50px !important;
}

.LinkItem-module__p-t-0___NVkie {
  padding-top: 0 !important;
}

.LinkItem-module__p-t-12___Ex0jV {
  padding-top: 12px !important;
}

.LinkItem-module__p-t-16___Fdst5 {
  padding-top: 16px !important;
}

.LinkItem-module__p-t-18____ZxXO {
  padding-top: 18px !important;
}

.LinkItem-module__p-t-20___nplQh {
  padding-top: 20px !important;
}

.LinkItem-module__p-t-30___bzBtH {
  padding-top: 30px !important;
}

.LinkItem-module__p-t-40___CGPWh {
  padding-top: 40px !important;
}

.LinkItem-module__p-t-50___bddnS {
  padding-top: 50px !important;
}

.LinkItem-module__p-l-20___d3eko {
  padding-left: 20px !important;
}

.LinkItem-module__p-l-30___gb_HJ {
  padding-left: 30px !important;
}

.LinkItem-module__p-l-40___BCPjL {
  padding-left: 40px !important;
}

.LinkItem-module__p-r-16___dZOkC {
  padding-right: 16px !important;
}

.LinkItem-module__p-r-20____GsB1 {
  padding-right: 20px !important;
}

.LinkItem-module__p-r-30___Vs1KX {
  padding-right: 30px !important;
}

.LinkItem-module__p-r-50___oLbI4 {
  padding-right: 50px !important;
}

.LinkItem-module__p-r-60___COPoe {
  padding-right: 60px !important;
}

.LinkItem-module__m-b-1___H4Eog {
  margin-bottom: 1px !important;
}

.LinkItem-module__m-b-2___JBDfM {
  margin-bottom: 2px !important;
}

.LinkItem-module__m-b-6___VZFmO {
  margin-bottom: 6px !important;
}

.LinkItem-module__m-b-8___LyJpV {
  margin-bottom: 8px !important;
}

.LinkItem-module__m-b-10___OIDf9 {
  margin-bottom: 10px !important;
}

.LinkItem-module__m-b-14___mqHtB {
  margin-bottom: 14px !important;
}

.LinkItem-module__m-b-16___SxkYr {
  margin-bottom: 16px !important;
}

.LinkItem-module__m-b-20___bi_Lo {
  margin-bottom: 20px !important;
}

.LinkItem-module__m-b-22___JO7fZ {
  margin-bottom: 22px !important;
}

.LinkItem-module__m-b-24___MhbGb {
  margin-bottom: 24px !important;
}

.LinkItem-module__m-b-30___QkYwX {
  margin-bottom: 30px !important;
}

.LinkItem-module__m-b-32___qGUN_ {
  margin-bottom: 32px !important;
}

.LinkItem-module__m-b-40___NP4KA {
  margin-bottom: 40px !important;
}

.LinkItem-module__m-t-2___JyfrT {
  margin-top: 2px !important;
}

.LinkItem-module__m-t-3___MEg8u {
  margin-top: 3px !important;
}

.LinkItem-module__m-t-4___g_ikU {
  margin-top: 4px !important;
}

.LinkItem-module__m-t-5___SpDpI {
  margin-top: 5px !important;
}

.LinkItem-module__m-t-8___n17Gx {
  margin-top: 8px !important;
}

.LinkItem-module__m-t-10___ZCIFe {
  margin-top: 10px !important;
}

.LinkItem-module__m-t-15___Wqv8H {
  margin-top: 15px !important;
}

.LinkItem-module__m-t-16___xMmdq {
  margin-top: 16px !important;
}

.LinkItem-module__m-t-20___sHsZM {
  margin-top: 20px !important;
}

.LinkItem-module__m-t-22___oRa6N {
  margin-top: 22px !important;
}

.LinkItem-module__m-t-30___j1bmW {
  margin-top: 30px !important;
}

.LinkItem-module__m-t-32___OKd7Q {
  margin-top: 32px !important;
}

.LinkItem-module__m-l-auto___zDJOI {
  margin-left: auto !important;
}

.LinkItem-module__m-l-4___oiDGF {
  margin-left: 4px !important;
}

.LinkItem-module__m-l-5___JklEf {
  margin-left: 5px !important;
}

.LinkItem-module__m-l-6____q0ph {
  margin-left: 6px !important;
}

.LinkItem-module__m-l-8___pLVNL {
  margin-left: 8px !important;
}

.LinkItem-module__m-l-10____mwC7 {
  margin-left: 10px !important;
}

.LinkItem-module__m-l-16___RX2Ow {
  margin-left: 16px !important;
}

.LinkItem-module__m-l-20___E8gSm {
  margin-left: 20px !important;
}

.LinkItem-module__m-l-24___ABqAk {
  margin-left: 24px !important;
}

.LinkItem-module__m-l-30___cILAs {
  margin-left: 30px !important;
}

.LinkItem-module__m-l-35___gRqFT {
  margin-left: 35px !important;
}

.LinkItem-module__m-l-40___xMHzZ {
  margin-left: 40px !important;
}

.LinkItem-module__m-r-8___sMeLq {
  margin-right: 8px !important;
}

.LinkItem-module__m-r-10___Ij_u3 {
  margin-right: 10px !important;
}

.LinkItem-module__m-r-16___SFHjW {
  margin-right: 16px !important;
}

.LinkItem-module__m-r-20___Iduh3 {
  margin-right: 20px !important;
}

.LinkItem-module__m-r-24___CbPLF {
  margin-right: 24px !important;
}

.LinkItem-module__m-r-30___hWb9f {
  margin-right: 30px !important;
}

.LinkItem-module__m-r-40___qrKxF {
  margin-right: 40px !important;
}

.LinkItem-module__border-r-3___x92Og {
  border-radius: 3px !important;
}

.LinkItem-module__border-r-4___jNUH6 {
  border-radius: 4px !important;
}

.LinkItem-module__border-r-6___F1T5x {
  border-radius: 6px !important;
}

.LinkItem-module__border-r-10___MhfhE {
  border-radius: 10px !important;
}

.LinkItem-module__border-r-12___rvylm {
  border-radius: 12px !important;
}

.LinkItem-module__border-r-16___tQloI {
  border-radius: 16px !important;
}

.LinkItem-module__border-r-50___B16is {
  border-radius: 50% !important;
}

.LinkItem-module__primary-border___fPWIk {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.LinkItem-module__primary-border-b___Fa6vv {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.LinkItem-module__primary-border-t___nCJJE {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.LinkItem-module__primary-border-l___pB6Jv {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.LinkItem-module__primary-border-r___DWZs5 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.LinkItem-module__secondary-border___eyw14 {
  border: 1px solid #637768;
}

.LinkItem-module__secondary-border-b___IyBO7 {
  border-bottom: 1px solid #637768;
}

.LinkItem-module__secondary-border-t___hXv2C {
  border-top: 1px solid #637768;
}

.LinkItem-module__secondary-border-l___WO3kS {
  border-left: 1px solid #637768;
}

.LinkItem-module__secondary-border-r___WNog9 {
  border-right: 1px solid #637768;
}

.LinkItem-module__gap-0___MCl_c {
  gap: 0 !important;
}

.LinkItem-module__gap-2___CtDhn {
  gap: 2px !important;
}

.LinkItem-module__gap-4___aVQhG {
  gap: 4px !important;
}

.LinkItem-module__gap-5___mUWlb {
  gap: 5px !important;
}

.LinkItem-module__gap-6___ubU7a {
  gap: 6px !important;
}

.LinkItem-module__gap-8___YHtG2 {
  gap: 8px !important;
}

.LinkItem-module__gap-10___JjLDK {
  gap: 10px !important;
}

.LinkItem-module__gap-12___Viaut {
  gap: 12px !important;
}

.LinkItem-module__gap-14___AmZCZ {
  gap: 14px !important;
}

.LinkItem-module__gap-16___xVjGM {
  gap: 16px !important;
}

.LinkItem-module__gap-18___FDukw {
  gap: 18px !important;
}

.LinkItem-module__gap-20___OUEr2 {
  gap: 20px !important;
}

.LinkItem-module__gap-24___EYOLH {
  gap: 24px !important;
}

.LinkItem-module__gap-26___M2atC {
  gap: 26px !important;
}

.LinkItem-module__gap-30___BAzE8 {
  gap: 30px !important;
}

.LinkItem-module__gap-32___j4cyc {
  gap: 32px !important;
}

.LinkItem-module__gap-40___GlZpn {
  gap: 40px !important;
}

.LinkItem-module__gap-50___JRCja {
  gap: 50px !important;
}

.LinkItem-module__flex-1___jVv0_ {
  flex: 1;
}

.LinkItem-module__flex-none___Z0vxt {
  flex: none !important;
}

.LinkItem-module__flex-column___iyxAC {
  display: flex;
  flex-direction: column !important;
}

.LinkItem-module__flex-row___JPMer {
  display: flex;
  flex-direction: row !important;
}

.LinkItem-module__vertically-centered___bBCaa {
  display: flex;
  align-items: center !important;
}

.LinkItem-module__horizontally-centered___gWvls {
  display: flex;
  justify-content: center !important;
}

.LinkItem-module__horizontally-end___uUiBj {
  display: flex;
  justify-content: end !important;
}

.LinkItem-module__vertically-start___vKGlX {
  display: flex;
  align-items: start !important;
}

.LinkItem-module__space-between___sZCkS {
  display: flex;
  justify-content: space-between !important;
}

.LinkItem-module__flex-wrap___VIm7j {
  flex-wrap: wrap !important;
}

.LinkItem-module__height-100___oHmyz {
  height: 100%;
}

.LinkItem-module__width-50___wylW9 {
  width: 50% !important;
}

.LinkItem-module__width-100____4nIJ {
  width: 100%;
}

.LinkItem-module__cursor-pointer___sLMz8 {
  cursor: pointer;
}

.LinkItem-module__cursor-not-allowed___xcZve {
  cursor: not-allowed !important;
}

.LinkItem-module__absolute-centered___eqLGI {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.LinkItem-module__absolute___s1Gsa {
  position: absolute;
}

.LinkItem-module__relative___hatXm {
  position: relative;
}

.LinkItem-module__fixed___gFEvl {
  position: fixed;
}

.LinkItem-module__visible___vRFkq {
  opacity: 1;
}

.LinkItem-module__invisible___MSD1V {
  opacity: 0;
}

.LinkItem-module__col-90___tLCYK {
  width: 90% !important;
}

.LinkItem-module__col-auto___Wdxna {
  width: auto !important;
}

.LinkItem-module__medical-tabs___vmfJa {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.LinkItem-module__medical-table-new___lr9vN {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.LinkItem-module__medical-table-new___lr9vN:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.LinkItem-module__medical-table-new___lr9vN::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.LinkItem-module__medical-table-new___lr9vN::-webkit-scrollbar-track {
  display: none;
}
.LinkItem-module__medical-table-new___lr9vN.LinkItem-module__no-pagination___vALpQ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.LinkItem-module__medical-table-new___lr9vN.LinkItem-module__no-pagination___vALpQ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.LinkItem-module__medical-table-new___lr9vN.LinkItem-module__no-pagination___vALpQ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.LinkItem-module__medical-table-new___lr9vN.LinkItem-module__no-pagination___vALpQ::-webkit-scrollbar-track {
  display: none;
}

.LinkItem-module__medical-table-empty___V6ch8 {
  padding: 14px 40px !important;
}

.LinkItem-module__icon-btn___P359i {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.LinkItem-module__search-icon___t2zVy {
  width: 24px;
  height: 24px;
  align-self: center;
}

.LinkItem-module__disable-select___BwKf_ {
  user-select: none;
}

.LinkItem-module__break-word___nGhP1 {
  word-break: break-word;
}

.LinkItem-module__popup-clear-btn___bxtty {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.LinkItem-module__scroll-m-b-20___VnUaO {
  scroll-margin-bottom: 20px;
}

.LinkItem-module__link___WHxJk {
  color: #375844;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/components/SectionAside/items/LinkItem/LinkItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,eAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.link {\n  color: get-color(greenNew, dark);\n  cursor: pointer;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `LinkItem-module__font-s-10___KOaTv`,
	"fontS12": `LinkItem-module__font-s-12___iQ7DA`,
	"fontS13": `LinkItem-module__font-s-13___VEyhH`,
	"fontS14": `LinkItem-module__font-s-14___nKWzM`,
	"fontS15": `LinkItem-module__font-s-15___f5fy6`,
	"fontS16": `LinkItem-module__font-s-16___NbIK9`,
	"fontS18": `LinkItem-module__font-s-18___xovZq`,
	"fontS20": `LinkItem-module__font-s-20___ZGAkI`,
	"fontS22": `LinkItem-module__font-s-22___anz9U`,
	"fontS28": `LinkItem-module__font-s-28___ILmrE`,
	"fontW400": `LinkItem-module__font-w-400___LivND`,
	"fontW500": `LinkItem-module__font-w-500___JIbu2`,
	"fontW600": `LinkItem-module__font-w-600___qscTn`,
	"fontW700": `LinkItem-module__font-w-700___dD0CJ`,
	"p5": `LinkItem-module__p-5____0pDY`,
	"p12": `LinkItem-module__p-12___Lltv7`,
	"p16": `LinkItem-module__p-16___xMxc7`,
	"p30": `LinkItem-module__p-30___x7PC_`,
	"pB0": `LinkItem-module__p-b-0___Vxp6z`,
	"pB5": `LinkItem-module__p-b-5___pofWt`,
	"pB10": `LinkItem-module__p-b-10___xkhUo`,
	"pB12": `LinkItem-module__p-b-12___bPEKo`,
	"pB16": `LinkItem-module__p-b-16___BMemU`,
	"pB18": `LinkItem-module__p-b-18___ESMkg`,
	"pB20": `LinkItem-module__p-b-20___D7hhQ`,
	"pB25": `LinkItem-module__p-b-25___GPpBP`,
	"pB30": `LinkItem-module__p-b-30___qTeyJ`,
	"pB50": `LinkItem-module__p-b-50___Vr1mj`,
	"pT0": `LinkItem-module__p-t-0___NVkie`,
	"pT12": `LinkItem-module__p-t-12___Ex0jV`,
	"pT16": `LinkItem-module__p-t-16___Fdst5`,
	"pT18": `LinkItem-module__p-t-18____ZxXO`,
	"pT20": `LinkItem-module__p-t-20___nplQh`,
	"pT30": `LinkItem-module__p-t-30___bzBtH`,
	"pT40": `LinkItem-module__p-t-40___CGPWh`,
	"pT50": `LinkItem-module__p-t-50___bddnS`,
	"pL20": `LinkItem-module__p-l-20___d3eko`,
	"pL30": `LinkItem-module__p-l-30___gb_HJ`,
	"pL40": `LinkItem-module__p-l-40___BCPjL`,
	"pR16": `LinkItem-module__p-r-16___dZOkC`,
	"pR20": `LinkItem-module__p-r-20____GsB1`,
	"pR30": `LinkItem-module__p-r-30___Vs1KX`,
	"pR50": `LinkItem-module__p-r-50___oLbI4`,
	"pR60": `LinkItem-module__p-r-60___COPoe`,
	"mB1": `LinkItem-module__m-b-1___H4Eog`,
	"mB2": `LinkItem-module__m-b-2___JBDfM`,
	"mB6": `LinkItem-module__m-b-6___VZFmO`,
	"mB8": `LinkItem-module__m-b-8___LyJpV`,
	"mB10": `LinkItem-module__m-b-10___OIDf9`,
	"mB14": `LinkItem-module__m-b-14___mqHtB`,
	"mB16": `LinkItem-module__m-b-16___SxkYr`,
	"mB20": `LinkItem-module__m-b-20___bi_Lo`,
	"mB22": `LinkItem-module__m-b-22___JO7fZ`,
	"mB24": `LinkItem-module__m-b-24___MhbGb`,
	"mB30": `LinkItem-module__m-b-30___QkYwX`,
	"mB32": `LinkItem-module__m-b-32___qGUN_`,
	"mB40": `LinkItem-module__m-b-40___NP4KA`,
	"mT2": `LinkItem-module__m-t-2___JyfrT`,
	"mT3": `LinkItem-module__m-t-3___MEg8u`,
	"mT4": `LinkItem-module__m-t-4___g_ikU`,
	"mT5": `LinkItem-module__m-t-5___SpDpI`,
	"mT8": `LinkItem-module__m-t-8___n17Gx`,
	"mT10": `LinkItem-module__m-t-10___ZCIFe`,
	"mT15": `LinkItem-module__m-t-15___Wqv8H`,
	"mT16": `LinkItem-module__m-t-16___xMmdq`,
	"mT20": `LinkItem-module__m-t-20___sHsZM`,
	"mT22": `LinkItem-module__m-t-22___oRa6N`,
	"mT30": `LinkItem-module__m-t-30___j1bmW`,
	"mT32": `LinkItem-module__m-t-32___OKd7Q`,
	"mLAuto": `LinkItem-module__m-l-auto___zDJOI`,
	"mL4": `LinkItem-module__m-l-4___oiDGF`,
	"mL5": `LinkItem-module__m-l-5___JklEf`,
	"mL6": `LinkItem-module__m-l-6____q0ph`,
	"mL8": `LinkItem-module__m-l-8___pLVNL`,
	"mL10": `LinkItem-module__m-l-10____mwC7`,
	"mL16": `LinkItem-module__m-l-16___RX2Ow`,
	"mL20": `LinkItem-module__m-l-20___E8gSm`,
	"mL24": `LinkItem-module__m-l-24___ABqAk`,
	"mL30": `LinkItem-module__m-l-30___cILAs`,
	"mL35": `LinkItem-module__m-l-35___gRqFT`,
	"mL40": `LinkItem-module__m-l-40___xMHzZ`,
	"mR8": `LinkItem-module__m-r-8___sMeLq`,
	"mR10": `LinkItem-module__m-r-10___Ij_u3`,
	"mR16": `LinkItem-module__m-r-16___SFHjW`,
	"mR20": `LinkItem-module__m-r-20___Iduh3`,
	"mR24": `LinkItem-module__m-r-24___CbPLF`,
	"mR30": `LinkItem-module__m-r-30___hWb9f`,
	"mR40": `LinkItem-module__m-r-40___qrKxF`,
	"borderR3": `LinkItem-module__border-r-3___x92Og`,
	"borderR4": `LinkItem-module__border-r-4___jNUH6`,
	"borderR6": `LinkItem-module__border-r-6___F1T5x`,
	"borderR10": `LinkItem-module__border-r-10___MhfhE`,
	"borderR12": `LinkItem-module__border-r-12___rvylm`,
	"borderR16": `LinkItem-module__border-r-16___tQloI`,
	"borderR50": `LinkItem-module__border-r-50___B16is`,
	"primaryBorder": `LinkItem-module__primary-border___fPWIk`,
	"primaryBorderB": `LinkItem-module__primary-border-b___Fa6vv`,
	"primaryBorderT": `LinkItem-module__primary-border-t___nCJJE`,
	"primaryBorderL": `LinkItem-module__primary-border-l___pB6Jv`,
	"primaryBorderR": `LinkItem-module__primary-border-r___DWZs5`,
	"secondaryBorder": `LinkItem-module__secondary-border___eyw14`,
	"secondaryBorderB": `LinkItem-module__secondary-border-b___IyBO7`,
	"secondaryBorderT": `LinkItem-module__secondary-border-t___hXv2C`,
	"secondaryBorderL": `LinkItem-module__secondary-border-l___WO3kS`,
	"secondaryBorderR": `LinkItem-module__secondary-border-r___WNog9`,
	"gap0": `LinkItem-module__gap-0___MCl_c`,
	"gap2": `LinkItem-module__gap-2___CtDhn`,
	"gap4": `LinkItem-module__gap-4___aVQhG`,
	"gap5": `LinkItem-module__gap-5___mUWlb`,
	"gap6": `LinkItem-module__gap-6___ubU7a`,
	"gap8": `LinkItem-module__gap-8___YHtG2`,
	"gap10": `LinkItem-module__gap-10___JjLDK`,
	"gap12": `LinkItem-module__gap-12___Viaut`,
	"gap14": `LinkItem-module__gap-14___AmZCZ`,
	"gap16": `LinkItem-module__gap-16___xVjGM`,
	"gap18": `LinkItem-module__gap-18___FDukw`,
	"gap20": `LinkItem-module__gap-20___OUEr2`,
	"gap24": `LinkItem-module__gap-24___EYOLH`,
	"gap26": `LinkItem-module__gap-26___M2atC`,
	"gap30": `LinkItem-module__gap-30___BAzE8`,
	"gap32": `LinkItem-module__gap-32___j4cyc`,
	"gap40": `LinkItem-module__gap-40___GlZpn`,
	"gap50": `LinkItem-module__gap-50___JRCja`,
	"flex1": `LinkItem-module__flex-1___jVv0_`,
	"flexNone": `LinkItem-module__flex-none___Z0vxt`,
	"flexColumn": `LinkItem-module__flex-column___iyxAC`,
	"flexRow": `LinkItem-module__flex-row___JPMer`,
	"verticallyCentered": `LinkItem-module__vertically-centered___bBCaa`,
	"horizontallyCentered": `LinkItem-module__horizontally-centered___gWvls`,
	"horizontallyEnd": `LinkItem-module__horizontally-end___uUiBj`,
	"verticallyStart": `LinkItem-module__vertically-start___vKGlX`,
	"spaceBetween": `LinkItem-module__space-between___sZCkS`,
	"flexWrap": `LinkItem-module__flex-wrap___VIm7j`,
	"height100": `LinkItem-module__height-100___oHmyz`,
	"width50": `LinkItem-module__width-50___wylW9`,
	"width100": `LinkItem-module__width-100____4nIJ`,
	"cursorPointer": `LinkItem-module__cursor-pointer___sLMz8`,
	"cursorNotAllowed": `LinkItem-module__cursor-not-allowed___xcZve`,
	"absoluteCentered": `LinkItem-module__absolute-centered___eqLGI`,
	"absolute": `LinkItem-module__absolute___s1Gsa`,
	"relative": `LinkItem-module__relative___hatXm`,
	"fixed": `LinkItem-module__fixed___gFEvl`,
	"visible": `LinkItem-module__visible___vRFkq`,
	"invisible": `LinkItem-module__invisible___MSD1V`,
	"col90": `LinkItem-module__col-90___tLCYK`,
	"colAuto": `LinkItem-module__col-auto___Wdxna`,
	"medicalTabs": `LinkItem-module__medical-tabs___vmfJa`,
	"medicalTableNew": `LinkItem-module__medical-table-new___lr9vN`,
	"noPagination": `LinkItem-module__no-pagination___vALpQ`,
	"medicalTableEmpty": `LinkItem-module__medical-table-empty___V6ch8`,
	"iconBtn": `LinkItem-module__icon-btn___P359i`,
	"searchIcon": `LinkItem-module__search-icon___t2zVy`,
	"disableSelect": `LinkItem-module__disable-select___BwKf_`,
	"breakWord": `LinkItem-module__break-word___nGhP1`,
	"popupClearBtn": `LinkItem-module__popup-clear-btn___bxtty`,
	"scrollMB20": `LinkItem-module__scroll-m-b-20___VnUaO`,
	"link": `LinkItem-module__link___WHxJk`
};
module.exports = ___CSS_LOADER_EXPORT___;
